import React from 'react';
import { useParams } from 'react-router-dom';

const TestMenu = () => {
    const params = useParams();
    console.log('TestMenu component loaded!', 'Params:', params);
    
    return (
        <div style={{ 
            padding: '20px', 
            backgroundColor: '#f0f0f0', 
            minHeight: '100vh',
            fontSize: '18px'
        }}>
            <h1 style={{ color: 'red' }}>✅ TEST MENU PAGE LOADED!</h1>
            <p>✅ Routing is working correctly!</p>
            <p><strong>Current URL:</strong> {window.location.href}</p>
            <p><strong>Route Params:</strong> {JSON.stringify(params)}</p>
            <p><strong>Language:</strong> {params.lng}</p>
            <hr />
            <h2>Next Steps:</h2>
            <p>1. ✅ Test route working</p>
            <p>2. 🔄 Switch to actual menu component</p>
            <p>3. 🎯 Test with real menu data</p>
        </div>
    );
};

export default TestMenu;
